import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://static.readdy.ai/image/9ce25d869b896a3f5b856271bcc15d01/04593552a0ea563d300a18e4891c8936.jpeg';

const NAV_LINKS = [
  { label: 'Meist', href: '#meist' },
  { label: 'Teenused', href: '#teenused' },
  { label: 'Kontakt', href: '#kontakt' },
];

const SERVICES_LINKS = [
  { label: 'Ehitusjäätmete käitlemine', href: '#teenused' },
  { label: 'Ehitusaegne vahekoristus', href: '#teenused' },
  { label: 'Abitööliste rent', href: '#teenused' },
  { label: 'Lõppkoristus', href: '#teenused' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A3828]">
      <div className="max-w-7xl mx-auto px-8 pt-16 pb-8">

        {/* Main grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">

          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-10 w-auto">
                <img src={LOGO_URL} alt="IISRAL Recycling OÜ" className="h-10 w-auto object-contain" />
              </div>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-leaf-line text-eco-green text-base" />
              <span className="text-eco-green text-sm font-bold">Mõtleme roheliselt</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs mb-6">
              Keskkonnasõbralikud lahendused ehitusjäätmete sorteerimiseks,
              taaskasutuseks ja koristustöödeks üle Eesti.
            </p>
            <div className="space-y-3">
              <a
                href="tel:+37253400444"
                className="flex items-center gap-3 text-white/60 hover:text-eco-green transition-colors cursor-pointer group"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-line text-base" />
                </div>
                <span className="text-sm font-medium">+372 53 400 444</span>
              </a>
              <a
                href="mailto:recycling@iisral.eu"
                className="flex items-center gap-3 text-white/60 hover:text-eco-green transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-line text-base" />
                </div>
                <span className="text-sm font-medium">recycling@iisral.eu</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.15em] mb-5">
              <a href="#meist">Navigatsioon</a>
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-eco-green transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.15em] mb-5">
              <a href="#teenused">Teenused</a>
            </h4>
            <ul className="space-y-3">
              {SERVICES_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-eco-green transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* ── Trust / Licenses ── */}
        <div className="border-t border-white/10 pt-8 mb-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-10">
            <div className="flex items-center gap-2 text-white/40 text-xs flex-shrink-0">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-check-line text-eco-green text-base" />
              </div>
              <span className="text-eco-green font-semibold text-xs uppercase tracking-wider">
                Tegutseme vastavalt kehtivatele lubadele
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-8">
              <div className="flex items-center gap-2">
                <i className="ri-truck-line text-white/30 text-sm" />
                <span className="text-white/40 text-xs">
                  Jäätmeveoluba: <span className="text-white/60 font-medium">RE.JÄ/521369</span>
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-recycle-line text-white/30 text-sm" />
                <span className="text-white/40 text-xs">
                  Jäätmekäitlusluba: <span className="text-white/60 font-medium">KL-521941</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider + copyright */}
        <div className="border-t border-white/10 pt-7 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} IISRAL Recycling OÜ. Kõik õigused kaitstud.
          </p>

          {/* Legal links */}
          <div className="flex items-center gap-5 flex-wrap justify-center">
            <Link
              to="/kasutustingimused"
              className="text-white/30 text-xs hover:text-eco-green transition-colors cursor-pointer whitespace-nowrap"
            >
              Kasutustingimused
            </Link>
            <span className="text-white/20 text-xs">·</span>
            <Link
              to="/privaatsuspoliitika"
              className="text-white/30 text-xs hover:text-eco-green transition-colors cursor-pointer whitespace-nowrap"
            >
              Privaatsuspoliitika
            </Link>
            <span className="text-white/20 text-xs">·</span>
            <Link
              to="/kupsiste-poliitika"
              className="text-white/30 text-xs hover:text-eco-green transition-colors cursor-pointer whitespace-nowrap"
            >
              Küpsiste poliitika
            </Link>
          </div>

          <div className="flex items-center gap-2 text-white/30 text-xs">
            <i className="ri-leaf-line text-eco-green text-sm" />
            <span>Mõtleme roheliselt</span>
          </div>
        </div>

        {/* Credit line */}
        <div className="mt-6 pt-5 border-t border-white/5 flex justify-center">
          <p className="text-white/50 text-xs">
            Digilahenduse pakub{' '}
            <a
              href="https://lumenat.io"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/50 hover:text-white/80 hover:underline transition-all duration-200 underline-offset-2"
            >
              Lumenatio
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
}
